/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable react/jsx-sort-props */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import validate from 'validate.js';
import { Grid } from '@mui/material';
import * as selectorsProdutos from '../../../store/produto/reducer';
import { saveProduto, updateProduto, findProdutoById } from '../../../store/produto/actions';
import moment from 'moment';
import { InputV2, DialogDefaultV2, ArquivoContainerV2, TrueFalseSelectV2 } from '../../../components/v2';
import { codeFormatter } from 'utils';
import ProdutoTamanhoTable from './ProdutoTamanhoTable';

const schema = {
  codigo: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
  nome: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
  possuiTamanho: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
  ativo: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
};

const Formulario = ({ saveProduto, updateProduto, selectedProduto, open, id, onClose, findProdutoById }) => {
  const [values, setValues] = useState({});
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (open) {
      setValues({
        data: moment().valueOf(),
        ativo: true,
      });
    } else {
      setValues({});
    }
  }, [open]);

  useEffect(() => {
    if (id) findProdutoById(id);
  }, [id, findProdutoById]);

  useEffect(() => {
    if (id && selectedProduto && id === selectedProduto.id) {
      if (!selectedProduto.data) selectedProduto.data = moment().valueOf();
      else selectedProduto.data = Number(selectedProduto.data);
      setValues(selectedProduto);
    } else {
      setValues({
        data: moment().valueOf(),
        ativo: true,
      });
    }
  }, [id, selectedProduto]);

  const onSave = () => {
    let erros = validate(values, schema);
    if ((values.possuiTamanho === "true" || values.possuiTamanho === true) && (!values.produtoTamanhos || values.produtoTamanhos.length === 0)) {
      erros = erros ? { ...erros, possuiTamanhoList: true } : { possuiTamanhoList: true };
    }
    setErrors(erros);
    if (!erros) {
      if (values.id) {
        updateProduto(values, saveCallback);
      } else {
        saveProduto(values, saveCallback);
      }
    }
  };

  const saveCallback = success => {
    if (success) {
      onCloseLocal(true);
    }
  };

  const onCloseLocal = isSave => {
    setErrors({});
    setValues({});
    onClose(isSave);
  };

  const handleChange = event => {
    setValues({
      ...values,
      [event.target.name]: event.target.value
    });
  };

  const onSaveTamanhos = produtoTamanhos => {
    setValues({
      ...values,
      produtoTamanhos
    });
  };

  return (
    <DialogDefaultV2
      open={open}
      handlerCancel={() => onCloseLocal(false)}
      handlerConfirm={onSave}
      title="Produto"
      confirmMessage="Salvar"
      maxWidth="md"
      fullWidth
    >
      <Grid container spacing={3}>
        <Grid size={{ xs: 12, sm: 3 }}>
          <InputV2
            label="Código"
            name="codigo"
            onChange={handleChange}
            value={values.codigo}
            isRequired
            error={!!(errors && errors.codigo)}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6 }}>
          <InputV2
            label="Nome"
            name="nome"
            onChange={handleChange}
            value={values.nome}
            isRequired
            error={!!(errors && errors.nome)}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 3 }}>
          <TrueFalseSelectV2
            error={!!(errors && errors.possuiTamanho)}
            isRequired
            label="Possui tamanho"
            name="possuiTamanho"
            onChange={handleChange}
            value={values.possuiTamanho}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 2 }}>
          <TrueFalseSelectV2
            error={!!(errors && errors.ativo)}
            isRequired
            label="Ativo"
            name="ativo"
            onChange={handleChange}
            value={values.ativo}
          />
        </Grid>
        {id && (
          <Grid size={{ xs: 12, sm: 3 }}>
            <InputV2
              disabled
              label="Quantidade total"
              value={values.quantidade}
            />
          </Grid>
        )}
        <Grid size={{ xs: 12 }}>
          <InputV2
            label="Descrição"
            name="descricao"
            onChange={handleChange}
            value={values.descricao}
            rows={3}
            multiline
          />
        </Grid>
        {(values.possuiTamanho === "true" || values.possuiTamanho === true) && (
          <ProdutoTamanhoTable
            tamanhos={values.produtoTamanhos}
            onSave={onSaveTamanhos}
            showError={!!(errors && errors.possuiTamanhoList)}
          />
        )}
        <ArquivoContainerV2
          arquivos={values.arquivos}
          onSave={arquivos => setValues({ ...values, arquivos })}
        />
      </Grid>
    </DialogDefaultV2>
  );
};

const mapStateToProps = state => ({
  selectedProduto: selectorsProdutos.getSelectedProduto(state),
});

const mapDispatchToProps = dispatch => bindActionCreators({
  saveProduto,
  updateProduto,
  findProdutoById,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Formulario);
